<template>
<section class="relative  bg-blueGray-50">
  <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
    <div class="absolute top-0 w-full h-full bg-top bg-cover" 
         :style="{'background-image': 'url(' + require('../assets/header-c.webp') + ')'}">
      <span id="overlay" class="w-full h-full absolute opacity-50 bg-black"></span>
    </div>
    <div class="container relative mx-auto">
      <div class="items-center flex flex-wrap">
        <div class="w-full lg:w-3/4 px-4 ml-auto mr-auto ">
          <h1 class="text-white font-display font-bold text-5xl leading-relaxed text-center">
            Odkrywaj najbardziej inspirujące przemówienia w historii.
          </h1>
          <div class="mx-auto py-10 grid text-white text-xl lg:grid-cols-4 gap-8">
            <div name="feature" class="text-center">
              <div class="text-center text-fuchsia-500 stroke-fuchsia-500 inline-block">
                <img style="" class="h-10 stroke-current" src="/search.png">
                </div>
              <p class="mt-4 text-md lg:text-center">
                Szukaj ulubionych przemówień i mówców.
              </p>
            </div>
            <div name="feature" class="text-center">
              <div class="text-center text-white stroke-current inline-block">
                <img style="" class="h-10 stroke-current" src="/collection.png">
                </div>
              <p class="mt-4 text-md lg:text-center">
                Oglądaj, słuchaj lub czytaj - Ty wybierasz.
              </p>
            </div>
            <div name="feature" class="text-center">
              <div class="text-center text-white stroke-current inline-block">
                <img style="" class="h-10 stroke-current" src="/quote.png">
                </div>
              <p class="mt-4 text-md lg:text-center">
                Poznawaj ważne cytaty.
              </p>
            </div>
            <div name="feature" class="text-center">
              <div class="text-center text-white stroke-current inline-block">
                <img style="" class="h-10 stroke-current" src="/speech.png">
              </div>
              <p class="mt-4 text-md lg:text-center">
                Trenuj przemowy
              </p>
            </div>
            
          </div>
        </div>
          </div>
        </div>
        <div class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px" style="transform: translateZ(0px)">
          <svg class="absolute bottom-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
            <polygon class="text-blueGray-200 fill-current" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
      </div>
      </section>
</template>

<script>
export default {
    name: 'Hero',
    data() {
        return {
            iconSize:46 
        }
    },
    methods:{
        doTravel: function(){
            this.$router.push({ name: 'entry', params: { id: this.entry.id } })
        }
    },
    components:{
    },
    props: {
        entry: {}
    }
}
</script>

<style scoped>
pre{
    font-size: x-small;
    height: 10vh;
    overflow:scroll;
}
</style>
